//Регулярное выражение для проверки корректности URL.
const URL_REGEX = new RegExp(
  '^(https?:\\/\\/)?' +
  '((([a-z0-9][a-z0-9-]*[a-z0-9]?)\\.)*([a-z0-9][a-z0-9-]*[a-z0-9]?)\\.[a-z]{2,}|localhost|' +
  '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|' +
  '\\[?[a-f0-9]*:[a-f0-9:%.]*\\]?)' +
  '(\\:\\d+)?(\\/[-a-z0-9+_.~;?&%=]*)*' +
  '(\\?[;&a-z0-9+_.~;?&%=]*)?' +
  '(\\#[-a-z0-9_]*)?$',
  'i'
);

// Регулярное выражение для проверки числового формата (целого или с плавающей точкой).
const NUMBER_FORMAT_REGEX = /^[0-9]*([.,][0-9]*)?$/;

export const REGEX = {
  URL_REGEX: URL_REGEX,
  NUMBER_FORMAT_REGEX: NUMBER_FORMAT_REGEX
}
